import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import { TextInput, Checkbox, Form } from '../../UI'
import moment from 'moment'
import { DEFAULT_PROFILE_PIC_SRC } from '../../../constants'
import getSymbolFromCurrency from 'currency-symbol-map'
import { validateRequired } from '../../../libs/validation'

class SetTravelers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      travelers: [],
      saving: false
    }
  }

  addTraveler() {
    let travelers = this.state.travelers.slice()
    travelers.push({})

    this.setState(
      {
        travelers: travelers
      },
      () => this.props.updateState(this.state)
    )
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps.currentState)
  }

  toggleOptions = () => {
    this.setState(
      {
        privateTour: !this.state.privateTour
      },
      () => this.props.updateState(this.state)
    )
  }

  handleFormChange(index, event) {
    let travelers = this.state.travelers.slice()
    let name = event.target.name

    if (name === 'age') {
      travelers[index][name] = event.target.value
      travelers[index].yearOfBirth = moment().year() - event.target.value
    } else {
      travelers[index][name] = event.target.value
    }

    this.setState(
      {
        travelers: travelers
      },
      () => {
        this.props.updateState(this.state)
      }
    )
  }

  handleGroupNumber(event) {
    let name = event.target.name
    this.setState(
      {
        [name]: parseInt(event.target.value)
      },
      () => this.props.updateState(this.state)
    )
  }

  onChange(event) {
    let name = event.target.name
    this.setState(
      {
        [name]: event.target.value
      },
      () => this.props.updateState(this.state)
    )

    switch (event.target.value) {
      case 'Solo':
        this.clearTravelers()
        break
      case 'Couple':
        if (!this.state.travelers.length) {
          this.addTraveler()
        } else {
          this.clearTravelers()
        }
        break
      case 'Group':
        this.clearTravelers()
        break
      default:
        if (!this.state.travelers.length) {
          this.addTraveler()
        }
        break
    }
  }

  handleSubmit = () => {
    this.props.jumpToStep(1)
  }

  clearTravelers = () => {
    this.setState(
      {
        travelers: [],
        partySize: 0
      },
      () => this.props.updateState(this.state)
    )
  }

  componentWillUnmount() {
    this.props.updateState(this.state)
  }

  render() {
    const { data, user, t } = this.props
    const { travelingType, travelers, partySize, privateTour } = this.state
    const imgSrc = user && user.userProfile.imageAvatar ? user.userProfile.imageAvatar.url : DEFAULT_PROFILE_PIC_SRC

    let submitBtnClass = this.state.travelingType ? 'btn btn-lg btn-primary btn-danger steps-submit-btn' : 'hidden'
    return (
      <Form onSubmit={this.handleSubmit} submitBtnClassname={submitBtnClass} submitBtnName={'Next'} submittingToServer={this.state.saving}>
        <div className="travellers-info">
          <div className="traveller">
            <img className="traveller__img" src={imgSrc} alt="" />
            <span className="traveller__name">{user ? user.userProfile.firstName + ' ' + user.userProfile.lastName : ''}</span>
          </div>

          <hr />

          <div className="group-type">
            <h3 className="sub-header">{t('group_type')}</h3>

            <div className="group-type__inputs">
              <div className="group-type__inputs__block">
                <select
                  name="travelingType"
                  className="form-control group__group-select"
                  onChange={e => this.onChange(e)}
                  value={travelingType}
                >
                  <option default selected disabled value="">
                    {t('choose')}
                  </option>
                  <option>{t('family')}</option>
                  <option>{t('friends')}</option>
                  <option>{t('couple')}</option>
                  <option>{t('solo')}</option>
                  <option>{t('group')}</option>
                  <option>{t('business')}</option>
                  <option>{t('other')}</option>
                </select>
              </div>
              <div className="group-type__inputs__block__last">
                <Checkbox handleChange={this.toggleOptions} value={privateTour} checked={privateTour} id="tour">
                  {`${t('private_tour')}
                  (${getSymbolFromCurrency(data.allLocalTours[0].currency)}${data.allLocalTours[0].privateTourPrice})`}
                </Checkbox>
              </div>
            </div>
          </div>

          <div className={travelingType && travelingType !== 'Solo' ? '' : 'hidden'}>
            <hr />

            <h3 className="sub-header">{t('travelling_with')}</h3>

            {travelers.map((partner, index) => (
              <div className="partner-form-wrapper" key={index}>
                <div className="partner__input-wrapper">
                  <label htmlFor="fullname">{t('full_name')}</label>
                  <TextInput
                    extraClass="large-input"
                    name="name"
                    initialValue={travelers[index].name}
                    validationFuncs={[validateRequired]}
                    onBlurExternal={e => this.handleFormChange(index, e)}
                    id="fullname"
                  />
                </div>
                <div className="partner__input-wrapper">
                  <label htmlFor="age">{t('age')}</label>
                  <TextInput
                    extraClass="small-input no-spin"
                    type="number"
                    name="age"
                    initialValue={travelers[index].age}
                    validationFuncs={[validateRequired]}
                    onBlurExternal={e => this.handleFormChange(index, e)}
                    maxChars={3}
                    id="age"
                  />
                </div>
              </div>
            ))}

            <div className={travelingType && travelingType === 'Group' ? 'form-group' : 'hidden'}>
              <label htmlFor="number-people">{t('number_people')}</label>
              <TextInput
                extraClass="large-input no-spin"
                type="number"
                name="partySize"
                placeholder="Example: 10-11"
                initialValue={partySize ? partySize : ''}
                onBlurExternal={e => this.handleGroupNumber(e)}
                id="number-people"
              />
            </div>

            <div
              className={
                travelingType &&
                travelers.length + 1 < data.allLocalTours[0].maxGroupSize &&
                travelingType !== 'Couple' &&
                travelingType !== 'Group'
                  ? 'add-traveler'
                  : 'hidden'
              }
              onClick={() => this.addTraveler()}
            >
              <img className="add-traveler__img" src="/img/plus.svg" alt="" /> {t('add_traveler')}
            </div>
          </div>
        </div>
      </Form>
    )
  }
}

const enhance = compose(translate('activity_booking_steps'))

export default enhance(SetTravelers)



// WEBPACK FOOTER //
// src/components/Activity/Steps/SetTravelers.jsx